<template>
    <v-menu 
    v-model="showMenu"
    centered right offset-y content-class="document-actions-menu" min-width="150">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
                <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-ellipsis-vertical-icon lucide-ellipsis-vertical">
                    <circle cx="12" cy="12" r="1" />
                    <circle cx="12" cy="5" r="1" />
                    <circle cx="12" cy="19" r="1" />
                </svg>
            </v-btn>
        </template>
        <v-card min-width="150" flat class="rounded-0">
            <v-list dense>
                <!-- <v-list-item @click.stop="$emit('view', document)">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Ver</v-list-item-title>
                </v-list-item> -->
                <v-list-item @click.stop="$emit('rename', document)">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Renombrar</v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="$emit('share', document)">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-share-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Compartir</v-list-item-title>
                </v-list-item>
                <v-list-item 
                v-if="$root.currentUser && $root.currentUser.premium"
                @click.stop="$emit('toggle-privacy', document), showMenu = false">
                    <v-list-item-icon class="mr-2">
                        <v-icon small :color="isPrivate ? 'orange' : 'grey'">
                            {{ isPrivate ? 'mdi-eye-off' : 'mdi-eye' }}
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{ isPrivate ? 'Hacer público' : 'Hacer privado' }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item 
                v-if="false"
                @click.stop="$emit('copy', document)">
                    <v-list-item-icon class="mr-2">
                        <v-icon small>mdi-content-copy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Crear copia</v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="$emit('delete', document)">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="error">mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="error--text">Eliminar</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    name: 'DocumentActionsMenu',
    props: {
        document: {
            type: Object,
            required: true
        },
        size: {
            type: Number,
            default: 24
        }
    },
    computed: {
        isPrivate() {
            // El documento es privado si show_community es false o 0
            return this.document.show_community === false || this.document.show_community === 0;
        }
    },
    data() {
        return {
            showMenu: false
        }
    }
};
</script>


<style>
.document-actions-menu {
    background-color: #f0f0f0;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>